import React, { useState, useEffect, useRef, useCallback } from 'react';

function Dropdown(props) {
    const containerRef = useRef(null);
    const labelRef = useRef(null);
    const selectBoxRef = useRef(null);
    const iconRef = useRef(null);

    const setFixedWidth = props.setFixedWidth !== undefined ? props.setFixedWidth : true;

    const [active, setActive] = useState(false);
    const [hidden, setHidden] = useState(setFixedWidth);

    // this determines initial index based on passed in label (which should be value, but is incosistent across implementations atm).
    let sIdx = (props.selectedItem && props.items) ? (props.items.findIndex(i => i.label == props.selectedItem)) : 0;
    if (sIdx < 0) sIdx = 0;
    const [selectedIndex, setSelectedIndex] = useState(sIdx)

    let resizeTimeoutId;

    const icon = (
        <svg id="cil-chevron-circle-down-alt" viewBox="0 0 512 512">
            <path fill="currentColor" d="M256,496A240,240,0,0,1,86.294,86.294,240,240,0,0,1,425.706,425.706,238.43,238.43,0,0,1,256,496Zm0-448C141.309,48,48,141.309,48,256s93.309,208,208,208,208-93.309,208-208S370.691,48,256,48Z"></path><polygon fill="currentColor" points="256 342.627 132.687 219.313 155.313 196.687 256 297.372 356.687 196.687 379.313 219.313 256 342.627"></polygon>
        </svg>
    );

    const toggleActive = () => {
        setActive(!active);
    }

    const blur = useCallback((e) => {
        if (containerRef.current) {
            if (!containerRef.current.contains(e.target)) {
                setActive(false);
            }
        }
    }, []);

    const setMaxWidth = () => {
        requestAnimationFrame(() => {
            if (selectBoxRef.current && containerRef.current && iconRef.current && labelRef.current) {
                let ref = selectBoxRef.current;
                let max = 0;
                for (let i = 0; i < ref.children.length; i++) {
                    let width = ref.children[i].firstElementChild.clientWidth;
                    max = width > max ? width : max;
                }

                if (max > 0) {
                    if (hidden) {
                        setTimeout(() => setHidden(false), 10);
                    }
                    let iconWidth = iconRef.current.clientWidth;
                    labelRef.current.style.minWidth = max + iconWidth + 24 + 'px';
                }
            }
        });
    }

    useEffect(() => {
        if (setFixedWidth) {
            setMaxWidth();
        }
    }, [selectBoxRef.current, containerRef.current, iconRef.current, labelRef.current])

    const handleResize = () => {
        if (resizeTimeoutId) {
            window.clearTimeout(resizeTimeoutId);
        }
        resizeTimeoutId = window.setTimeout(() => {
            if (setFixedWidth && selectBoxRef.current) {
                setMaxWidth();
            }
            resizeTimeoutId = false;
        }, 50)
    }

    useEffect(() => {
        let isMounted = true;
        const _handleResize = () => {
            if (isMounted && setFixedWidth) {
                setMaxWidth();
            }
        }

        const _blur = (e) => {
            if (isMounted) {
                blur(e);
            }
        }

        if (isMounted) {
            handleResize();
            window.addEventListener('resize', _handleResize);
            window.addEventListener('click', _blur);
        }

        return () => {
            isMounted = false;
            if (resizeTimeoutId) {
                window.clearTimeout(resizeTimeoutId);
            }
            window.removeEventListener('resize', _handleResize);
            window.removeEventListener('resize', _blur);
        }
    }, [])

    //console.log('label', props.items, props.selectedItem ,props.items.find(i => i.value == props.selectedItem));
    //const selectedLabel = props.items.find(i => i.value == props.selectedItem).label;

    return (
        <div className={`dropdown ${hidden && 'hidden'} ${(props.className ? props.className : '')}`} onClick={toggleActive} ref={containerRef}>

            <div className="dropdown-label" ref={labelRef}>
                <span>{props.selectedItem}</span>
                {/* <span>{props.items[selectedIndex].label}</span> */}
                <span className="svg-icon" ref={iconRef}>{icon}</span>
            </div>

            <div className={`select-box ${active && 'active'} ${props.reverse && 'reverse'}`} ref={selectBoxRef}>
                {props.items && props.items.map((item, index) => {
                    let disabled = false;
                    if (typeof item.disabled != 'undefined') {
                        disabled = item.disabled;
                    }

                    return (<div
                        key={item.value}
                        className={"dropdown-label-option" + (disabled ? ' disabled' : '')}
                        onMouseDown={() => {
                            if (!disabled) {
                                setSelectedIndex(index);
                                props.setSelection(item.value);
                                setActive(false);
                            }
                        }}
                    >
                        <span>{item.label}</span>
                    </div>)
                })}
            </div>

        </div>
    )
}

export default Dropdown;